import { format } from "date-fns";

export const convertDateToBE = (
    date: Date | string | null | undefined
): string | null => {
    if (!date) return null;

    if (typeof date === "string") {
        date = new Date(date);
        const offset = date.getTimezoneOffset();
        date.setMinutes(date.getMinutes() + offset);
    }

    return format(date, "yyyy/MM/dd");
};

export const convertDateToMobile = <T>(
    date: Date | string | null | undefined
): string | null | T => {
    if (!date) return null;
    if (typeof date !== "string") {
        return format(date, "yyyy-MM-dd");
    }
};

export const convertDateResponse = (dateResponse: string) => {
    if (!dateResponse) return null;
    const yearMonthDay = dateResponse.split("T")[0];
    const splitMonthDateYear = yearMonthDay.split("-");
    const year = parseInt(splitMonthDateYear[0]);
    const month = parseInt(splitMonthDateYear[1]) - 1;
    const day = parseInt(splitMonthDateYear[2]);

    return new Date(year, month, day);
};

export const dateRangeToString = (
    startDate: string | Date,
    endDate: string | Date,
    naText?: string
) => {
    naText = naText ?? "n/a";
    if (!startDate && !endDate) return naText;
    const _start =
        startDate instanceof Date
            ? format(startDate, "MM/dd/yyyy")
            : startDate
            ? format(new Date(startDate + "T12:00:00"), "MM/dd/yyyy")
            : naText;
    const _end =
        endDate instanceof Date
            ? format(endDate, "MM/dd/yyyy")
            : !!endDate
            ? format(new Date(endDate + "T12:00:00"), "MM/dd/yyyy")
            : naText;
    return [_start, _end].join(" - ");
};
